<section class="ia-note" [attr.aria-label]="title">
  <div class="ia-note__heading">
    <label class="ia-note__title" [attr.for]="editing ? inputId : null">{{ title }}</label>
    <button *ngIf="!editing" #editButton type="button" class="btn btn-secondary btn-sm"
      [attr.aria-label]="'Edit ' + title.toLowerCase()" (click)="startEdit()">Edit</button>
  </div>
  <ng-container *ngIf="!editing; else editor">
    <div *ngIf="value; else empty" class="ia-note__value" [innerHTML]="value | replaceLineBreaks"></div>
    <ng-template #empty><p class="ia-note__empty">No notes yet.</p></ng-template>
  </ng-container>
  <ng-template #editor>
    <textarea #noteInput class="form-control" [id]="inputId" rows="3" [value]="draft" (input)="updateDraft($event)"></textarea>
    <div class="ia-note__actions">
      <button type="button" class="btn btn-secondary btn-sm" [attr.aria-label]="'Cancel ' + title.toLowerCase()" (click)="cancel()">Cancel</button>
      <button type="button" class="btn btn-primary btn-sm" [attr.aria-label]="'Save ' + title.toLowerCase()" (click)="save()">Save</button>
    </div>
  </ng-template>
</section>
